export default __webpack_public_path__ + "5677fc4dab898a163b650a9a68b8da14.webp";